/**
 * PDP Accordion Auto-Collapse Handler
 * Ensures only one accordion is open at a time on product pages
 */

class PDPAccordionHandler {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupAccordions());
    } else {
      this.setupAccordions();
    }
  }

  setupAccordions() {
    // Find all accordion containers on the product page
    const accordionContainers = document.querySelectorAll('.accordion');

    accordionContainers.forEach((container) => {
      this.handleAccordionContainer(container);
    });
  }

  /**
   * Handle accordion auto-collapse for a container
   * @param {HTMLElement} container - The accordion container element
   */
  handleAccordionContainer(container) {
    const accordions = container.querySelectorAll('accordion-custom');

    accordions.forEach((accordion) => {
      const details = accordion.querySelector('details');
      const summary = accordion.querySelector('summary');

      if (!details || !summary) return;

      // Add click listener to handle auto-collapse
      summary.addEventListener('click', () => {
        // Only proceed if accordion is currently closed (about to open)
        if (!details.open) {
          this.closeOtherAccordions(container, accordion);
        }
      });
    });
  }

  /**
   * Close all accordions except the current one
   * @param {HTMLElement} container - The accordion container element
   * @param {HTMLElement} currentAccordion - The accordion that should stay open
   */
  closeOtherAccordions(container, currentAccordion) {
    const allAccordions = container.querySelectorAll('accordion-custom');

    allAccordions.forEach((accordion) => {
      if (accordion !== currentAccordion) {
        const details = accordion.querySelector('details');
        if (details) {
          details.open = false;
        }
      }
    });
  }
}

// Initialize the handler
new PDPAccordionHandler();
